// extracted by mini-css-extract-plugin
export var formContainer = "_jn-0";
export var message = "_jn-1";